import React from 'react';
import { CheckoutProvider } from './Checkout.context';
import StripeCheckout from './variations/Stripe';
import useCheckout from '../../hooks/use-checkout/use-checkout';
import useQueryParams from '../../hooks/use-queryparams/use-queryparams';
import { ObjectPropsPropType } from '../../services/proptypes';
import './Checkout.css';
var defaultProps = {
  defaultCheckoutData: undefined,
  onReturnToCatalogPage: null,
  checkoutUuid: null,
  order: {}
};
export default function Checkout(_ref) {
  var children = _ref.children,
    orderUuid = _ref.orderUuid,
    checkoutUuid = _ref.checkoutUuid,
    paymentChannel = _ref.paymentChannel,
    defaultCheckoutData = _ref.defaultCheckoutData,
    onReturnToCatalogPage = _ref.onReturnToCatalogPage,
    order = _ref.order,
    cartHook = _ref.cartHook;
  // move this to the checkout page
  // change prop signature to orderId
  var orderIdFromQueryParam = useQueryParams('order_id');
  var checkoutIdFromQueryParam = useQueryParams('checkout_id');
  var finalOrderId = orderUuid || orderIdFromQueryParam;
  var finalCheckoutId = checkoutUuid || checkoutIdFromQueryParam;
  var checkout = useCheckout(finalOrderId, paymentChannel, {
    defaultCheckoutData: defaultCheckoutData,
    originalOrder: order,
    checkoutUuid: finalCheckoutId,
    cartHook: cartHook // once useCheckout and useCart are refactored into a single hook, remove this
  });
  var context = {
    checkout: checkout,
    orderUuid: orderUuid,
    onReturnToCatalogPage: onReturnToCatalogPage
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "payment-checkout"
  }, /*#__PURE__*/React.createElement(CheckoutProvider, {
    value: context
  }, children));
}
Checkout.defaultProps = defaultProps;
Checkout.Stripe = StripeCheckout;